import tw, { styled } from 'twin.macro';

export const SectionWrapper = styled.section`
  ${tw`relative py-8 md:py-12 lg:py-16`};

  .intro {
    ${tw`relative rounded-r-2xl px-8 py-10 md:pl-12 lg:pl-16 md:py-12 lg:py-16`};
    background-color: #f1f8fe;

    &:before {
      ${tw`bg-no-repeat absolute -top-14 right-8 content bg-right`};
      background-image: var(--section-image);
      height: calc(100% + 3.5rem);
      filter: opacity(0.8);
      width: 308px;

      @media (max-width: 512px) {
        filter: opacity(0.5);
      }
    }
    
    h2 {
      font-family: Quicksand;
      line-height: 32.5px;
      font-weight: 600;
      font-size: 24px;
      ${tw`relative`};
      color: #007996;
    }

    p {
      ${tw`relative md:w-3/5`};
      font-family: Quicksand;
      line-height: 30.6px;
      font-weight: 400;
      font-size: 18px;
      color: #6d6d88;
    }
  }

  .sub-features {
    ${tw`grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 px-8 md:pr-0 md:pl-6 lg:pl-8 py-5`};
  }
`;

export const SectionCardWrapper = styled.div`
  ${tw`flex flex-col relative rounded-2xl p-8 md:py-12 cursor-pointer`};
  transition: all .5s ease-in-out;
  border: 0.2px solid transparent;

  &:hover {
    box-shadow: 0px 1px 15px 0px #c4c4c440;
    border-color: #1a8caf;
  }

  .icon {
    ${tw`w-10 h-10`}

    img {
      ${tw`w-full h-full`};
    }
  }

  h3 {
    margin-bottom: 6px !important;
    font-family: Quicksand;
    line-height: 25.19px;
    font-weight: 500;
    font-size: 18px;
    color: #4f4f4f:
  }

  p {
    font-family: Quicksand;
    line-height: 26.32px;
    font-weight: 400;
    font-size: 16px;
    color: #6d6d88;
  }
`;

export const StickyListWrapper = styled.ul`
  ${tw`sticky hidden md:flex flex-col top-16 list-none lg:w-3/12 xl:w-2/12 pr-8 md:pr-12 lg:pr-16 m-0 pt-6 md:pt-8 lg:pt-12 md:pb-12`};

  li {
    ${tw`flex justify-end gap-2`};
    font-family: Quicksand;
    font-weight: 500;
    font-size: 14px;
    color: #7D7C7C;

    &:hover, &:focus {
      button, span {
        font-weight: 700;
      }

      button {
        color: #007996;
      }
    }

    button {
      ${tw`border-none bg-transparent p-2 m-0 cursor-pointer whitespace-nowrap`};
      font-family: Quicksand;
      font-weight: 500;
      font-size: 14px;
      color: #7d7c7c;
    }
  }
`;